<div class="container-fluid mb-5 padding-0 ns-home">
  <div class="ltms-tabs lato-bold-dark">
    <div
      class="ltms-tab"
      *ngIf="tabVisibility.sequence"
      [class.ltms-active-tab]="activeTab === 'sequence'"
      (click)="toggleTab('sequence')"
    >
      Invites &amp; reminders
    </div>
    <div
      class="ltms-tab"
      *ngIf="tabVisibility.backup"
      [class.ltms-active-tab]="activeTab === 'backup'"
      [class.is-guide]="guidingBackup"
      (click)="toggleTab('backup')"
    >
      Backup Attempt
    </div>
    <div
      class="ltms-tab"
      *ngIf="tabVisibility.filters"
      [class.ltms-active-tab]="activeTab === 'filters'"
      (click)="toggleTab('filters')"
    >
      Filters &amp; timing
    </div>
    <div
      class="ltms-tab"
      *ngIf="tabVisibility.blacklist"
      [class.ltms-active-tab]="activeTab === 'blacklist'"
      (click)="toggleTab('blacklist')"
    >
      Blacklist / DND
    </div>
    <div
      class="ltms-tab"
      *ngIf="tabVisibility.unsubscribe"
      [class.ltms-active-tab]="activeTab === 'unsubscribe'"
      (click)="toggleTab('unsubscribe')"
    >
      Unsubscribe list
    </div>
    <div
      class="ltms-tab"
      *ngIf="tabVisibility.templates"
      [class.ltms-active-tab]="activeTab === 'templates'"
      (click)="toggleTab('templates')"
    >
      Templates
    </div>
  </div>

  <p class="ns-guide" *ngIf="guidingBackup && activeTab === 'filters'">
    On-demand is on. Opening <strong>Backup Attempt</strong> next so you can set delays, channels, and templates.
  </p>

  <div class="ns-home__body" *ngIf="tabVisibility.sequence || tabVisibility.backup || tabVisibility.filters || tabVisibility.blacklist || tabVisibility.unsubscribe || tabVisibility.templates">
    <app-channel-sequence
      *ngIf="activeTab === 'sequence' && tabVisibility.sequence"
      [isWriteAllowed]="tabWrite.sequence"
      setupMode="invites"
    ></app-channel-sequence>
    <app-channel-sequence
      *ngIf="activeTab === 'backup' && tabVisibility.backup"
      [isWriteAllowed]="tabWrite.backup"
      setupMode="on_demand"
    ></app-channel-sequence>
    <app-channel-filter-timing
      *ngIf="activeTab === 'filters' && tabVisibility.filters"
      [isWriteAllowed]="tabWrite.filters"
      (onDemandEnabled)="startBackupSetupGuide()"
    ></app-channel-filter-timing>
    <app-channel-blacklist
      *ngIf="activeTab === 'blacklist' && tabVisibility.blacklist"
      [isWriteAllowed]="tabWrite.blacklist"
    ></app-channel-blacklist>
    <app-channel-unsubscribe
      *ngIf="activeTab === 'unsubscribe' && tabVisibility.unsubscribe"
      [isWriteAllowed]="tabWrite.unsubscribe"
    ></app-channel-unsubscribe>
    <app-channel-templates
      *ngIf="activeTab === 'templates' && tabVisibility.templates"
      [isWriteAllowed]="tabWrite.templates"
    ></app-channel-templates>
  </div>

  <div class="ns-home__empty" *ngIf="!tabVisibility.sequence && !tabVisibility.backup && !tabVisibility.filters && !tabVisibility.blacklist && !tabVisibility.unsubscribe && !tabVisibility.templates">
    You do not have permission to view Notification Setup.
  </div>
</div>
